export * from './precios.component';
export * from './precio-dialog.component';
export * from './filters-precios-dialog.component';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/precios-seccion/precios/index.ts